export enum CookieConsent {
    All = 'all',
    Basic = 'basic'
}
